// shared.module.ts
import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LitmusFooterComponent } from './footer/litmus-footer.component';
import { LitmusHeaderComponent } from './header/litmus-header.component';
import { WebPushNotificationComponent } from './web-push-notification/web-push-notification.component';
import { SideBarComponent } from './side-bar/side-bar.component';
import { MenuItemComponent } from './side-bar/menu-item/menu-item.component';
import { RouterModule } from '@angular/router';
import { CalendarComponent } from './calendar/calendar.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
// import { LoaderComponent } from './loader/loader.component';

import { LtmsFilterDrawComponent } from '../filters/ltms-global-filter-draw/ltms-global-filter-draw.component';
import { HierarhyFilterButtonComponent } from '../filters/ltms-global-filter-draw/sub-component/hierarhy-filter-button/hierarhy-filter-button.component';
import { AddFiltersButtonComponent } from '../filters/ltms-global-filter-draw/sub-component/add-filters-button/add-filters-button.component';
import { ActiveFiltersChipsComponent } from '../filters/ltms-global-filter-draw/sub-component/active-filters-chips/active-filters-chips.component';
import { LtmsGlobalFilterSideBarComponent } from '../filters/ltms-global-filter-side-bar/ltms-global-filter-side-bar.component';

import { ReactiveFormsModule } from '@angular/forms';
import { LtmsGlobalFilterByHierarchyComponent } from '../filters/ltms-global-filter-by-hierarchy/ltms-global-filter-by-hierarchy.component';
import { LtmsGlobalFilterByDimensionComponent } from '../filters/ltms-global-filter-by-dimension/ltms-global-filter-by-dimension.component';
import { LtmsActiveGlobalFilterComponent } from '../filters/ltms-active-global-filter/ltms-active-global-filter.component';
import { LtmsSavedGlobalFilterComponent } from '../filters/ltms-saved-global-filter/ltms-saved-global-filter.component';
import { DoughnutViewComponent } from './doughnut-view/doughnut-view.component';
import { ProgressBarComponent } from './progressBar/progress-bar/progress-bar.component';
import { LtmsDoughnutChartViewComponent } from './graph/ltms-doughnut-chart-view/ltms-doughnut-chart-view.component';
import { LtmsGroupBarChartViewComponent } from './graph/ltms-group-bar-chart-view/ltms-group-bar-chart-view.component';
import { FormsModule } from '@angular/forms';
import { ChangeAccessLevelComponent } from '../../features/manager/change-access-level/change-access-level.component';
import { ChangePasswordComponent } from '../../features/manager/change-password/change-password.component';
import { LtmsDropdownComponent } from './ltms-dropdown/ltms-dropdown.component';
import { LtmsDataTableComponent } from './ltms-data-table/ltms-data-table.component';
import { LtmsLineChartViewComponent } from './graph/ltms-line-chart-view/ltms-line-chart-view.component';
import { LtmsBarChartViewComponent } from './graph/ltms-bar-chart-view/ltms-bar-chart-view.component';
import { OrderByPipe } from '../pipes/order-by/order-by.pipe';
import { IndianNumberFormatPipe } from '../pipes/format-number/format-number.pipe';
import { LtmsWidgetToolsComponent } from './ltms-widget-tools/ltms-widget-tools.component';
import { TooltipComponent } from './graph/tooltip/tooltip.component';
import { LtmsDownloadWidgetComponent } from './ltms-download-widget/ltms-download-widget.component';
import { LtmsDaterangePickerComponent } from './ltms-daterange-picker/ltms-daterange-picker.component';
import { LtmsTooltipDirective } from './ltms-tooltip/ltms-tooltip.directive';
import { LtmsLoaderComponent } from './ltms-loader/ltms-loader.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { LtmsDataTableV2Component } from './ltms-data-table-v2/ltms-data-table-v2.component';
import { LtmsResizableDirective } from './ltms-resizable/ltms-resizable.directive';
import { LitmusMiniRaterComponent } from './ltms-data-table-v2/sub-components/litmus-mini-rater/litmus-mini-rater.component';
import { NpsMiniRaterComponent } from './ltms-data-table-v2/sub-components/nps-mini-rater/nps-mini-rater.component';
import { LtmsDrilldownTableComponent } from './ltms-drilldown-table/ltms-drilldown-table.component';
import { LtmsDashboardThemesComponent } from "./ltms-dashboard-themes/ltms-dashboard-themes.component";
import { LtmsCustomTabComponent } from './ltms-custom-tab/ltms-custom-tab.component';
import { EngagementLiteComponent } from './engagement/engagement-lite/engagement-lite.component';
import { EngagementProComponent } from './engagement/engagement-pro/engagement-pro.component';
import { EngagementDetailsComponent } from './engagement/engagement-details/engagement-details.component';
import {EngagementStackbarComponent} from './engagement/engagement-pro/components/engagement-stackbar/engagement-stackbar.component';
import { EngagementDoughnutChartComponent } from './engagement/engagement-pro/components/engagement-doughnut-chart/engagement-doughnut-chart.component';
import { EngagementCardsComponent } from './engagement/engagement-lite/components/engagement-cards/engagement-cards.component';
import { LtmsErrorComponent } from './ltms-error/ltms-error.component';
import { FeedDetailPanelComponent } from './feed-detail-panel/feed-detail-panel.component';
// import { LtmsSearchBoxComponent } from './ltms-search-box/ltms-search-box.component';

import { ResponsePanelComponent } from './feed-detail-panel/sub-components/response-panel/response-panel.component';
import { InformationPanelComponent } from './feed-detail-panel/sub-components/information-panel/information-panel.component';
import { ChatPanelComponent } from './feed-detail-panel/sub-components/chat-panel/chat-panel.component';
import { HistoryPanelComponent } from './feed-detail-panel/sub-components/history-panel/history-panel.component';
import { LtmsBannerComponent } from './ltms-banner/ltms-banner.component';
import { HuddleCreationComponent } from 'src/app/features/projects/huddle/huddle-creation/huddle-creation.component';
import { ScoreSummaryComponent } from './score/score-summary/score-summary.component';
import { ScoreTrendsComponent } from './score/score-trends/score-trends.component';
import { ScoreDetailsComponent } from './score/score-details/score-details.component';
import { VerbatimHomeComponent } from './verbatim-home/verbatim-home.component';
// Remove these imports since they are standalone components
// import { ResponseControllerComponent } from './feed-detail-panel/sub-components/response-panel/response-controller/response-controller.component';
// import { ActionEditModalComponent } from 'src/app/features/projects/huddle/action-edit-modal/action-edit-modal.component';
import { LtmsCustomFieldRenderComponent } from './ltms-custom-field-render/ltms-custom-field-render.component';
import { LitmusFeedListViewComponent } from './litmus-feed-list-view/litmus-feed-list-view.component';
import { ScoreDetailsTableComponent } from './score/score-details-table/score-details-table.component';
import { ScoreDropdownMenuComponent } from './score/score-dropdown-menu/score-dropdown-menu.component';
import { ScoreSummaryNpsMeterComponent } from './score/score-summary-nps-meter/score-summary-nps-meter.component';
import { ScoreDoughnutChartComponent } from './score/score-doughnut-chart/score-doughnut-chart.component';
import { ScoreComparisonComponent } from './score/score-comparison/score-comparison.component';
import { ScoreWidgetComponent } from './score/score-widget/score-widget.component';
import { ScoreSearchBarComponent } from './score/score-search-bar/score-search-bar.component';
import { ScoreComparisonNpsMeterComponent } from './score/score-comparison-nps-meter/score-comparison-nps-meter.component';
import { ScoreTableComponent } from './score/score-table/score-table.component';
import { ScoreOverlayEffectComponent } from './score/score-overlay-effect/score-overlay-effect.component';
import { ScoreLineChartComponent } from './score/score-line-chart/score-line-chart.component';
import { ScoreBarChartComponent } from './score/score-bar-chart/score-bar-chart.component';
// import { LtmsSearchBoxComponent } from './litmus-components/ltms-search-box/ltms-search-box.component';
import { LitmusResponseDownloaderComponent } from './litmus-response-downloader/litmus-response-downloader.component';
import { RelationshipViewPanelComponent } from "./feed-detail-panel/sub-components/relationship-view-panel/relationship-view-panel.component";
import { ScoreQuestionDetailsComponent } from './score/score-question-details/score-question-details.component';
import { ScoreQuestionComponent } from './score/score-question/score-question.component';
import { ScoreCustomComponent } from './score/score-custom/score-custom.component';
import { ScoreOverviewComponent } from './score/score-overview/score-overview.component';
import { OverviewTableComponent } from './score/score-overview/sub-component/overview-table/overview-table.component';
import { ScoreQuestionBarChartComponent } from './score/score-question-bar-chart/score-question-bar-chart.component';
import { ScoreQuestionTabHorizonatalBarChartComponent } from './score/score-question-tab-horizonatal-bar-chart/score-question-tab-horizonatal-bar-chart.component';
import { HolidayCalendarComponent } from './holiday-calendar/holiday-calendar.component';
import { HuddleDropdownMenuComponent } from './huddle-dropdown-menu copy/huddle-dropdown-menu.component';
import { SuggestionEditModalComponent } from 'src/app/features/projects/huddle/suggestion-edit-modal/suggestion-edit-modal.component';
import { EngagementSummaryComponent } from './engagement/engagement-summary/engagement-summary.component';
import { EngagementRecordsSummaryDrilldownComponent } from './engagement/engagement-summary/components/engagement-records-summary-drilldown/engagement-records-summary-drilldown.component';
import { EngagementChannelPerformanceComponent } from './engagement/engagement-summary/components/engagement-channel-performance/engagement-channel-performance.component';
import { ScoreTrendsNewComponent } from './score/score-trends-new/score-trends-new.component';
import { ScoreDrilldownTableNewComponent } from './score/score-drilldown-table-new/score-drilldown-table-new.component';
import { ScoreDrilldownBarChartComponent } from './score/score-drilldown-bar-chart/score-drilldown-bar-chart.component';
import { SentimentAnalysisComponent } from './sentiment-analysis/sentiment-analysis-home/sentiment-analysis.component';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

@NgModule({
    exports: [
        RouterModule,
        LitmusFooterComponent,
        LitmusHeaderComponent,
        LtmsFilterDrawComponent,
        AddFiltersButtonComponent,
        HierarhyFilterButtonComponent,
        ActiveFiltersChipsComponent,
        LtmsDoughnutChartViewComponent,
        LtmsGlobalFilterSideBarComponent,
        LtmsGlobalFilterByHierarchyComponent,
        LtmsGlobalFilterByDimensionComponent,
        LtmsActiveGlobalFilterComponent,
        LtmsSavedGlobalFilterComponent,
        WebPushNotificationComponent,
        SideBarComponent,
        MenuItemComponent,
        DoughnutViewComponent,
        ProgressBarComponent,
        ChangeAccessLevelComponent,
        ChangePasswordComponent,
        LtmsDropdownComponent,
        LtmsDataTableComponent,
        LtmsLineChartViewComponent,
        LtmsBarChartViewComponent,
        OrderByPipe,
        IndianNumberFormatPipe,
        LtmsWidgetToolsComponent,
        LtmsDownloadWidgetComponent,
        LtmsDaterangePickerComponent,
        LtmsLoaderComponent,
        LtmsDataTableV2Component,
        LtmsResizableDirective,
        LitmusMiniRaterComponent,
        NpsMiniRaterComponent,
        LtmsDrilldownTableComponent,
        LtmsCustomTabComponent,
        EngagementSummaryComponent,
        EngagementLiteComponent,
        EngagementProComponent,
        EngagementDetailsComponent,
        EngagementStackbarComponent,
        EngagementDoughnutChartComponent,
        LtmsErrorComponent,
        FeedDetailPanelComponent,
        // LtmsSearchBoxComponent,
        // DownloadService
        VerbatimHomeComponent,
        LtmsBannerComponent,
        ScoreSummaryComponent,
        ScoreTrendsComponent,
        ScoreDetailsComponent,
        LtmsCustomFieldRenderComponent,
        HuddleCreationComponent,
        LitmusFeedListViewComponent,
        ScoreDetailsTableComponent,
        ScoreDropdownMenuComponent,
        ScoreSummaryNpsMeterComponent,
        ScoreDoughnutChartComponent,
        ScoreComparisonComponent,
        ScoreWidgetComponent,
        ScoreSearchBarComponent,
        ScoreComparisonNpsMeterComponent,
        ScoreTableComponent,
        ScoreOverlayEffectComponent,
        ScoreLineChartComponent,
        ScoreBarChartComponent,
        LitmusResponseDownloaderComponent,
        RelationshipViewPanelComponent,
        ScoreQuestionDetailsComponent,
        ScoreQuestionComponent,
        ScoreCustomComponent,
        ScoreOverviewComponent,
        OverviewTableComponent,
        ScoreQuestionBarChartComponent,
        ScoreQuestionTabHorizonatalBarChartComponent,
        ScoreQuestionComponent,
        HuddleDropdownMenuComponent,
        SuggestionEditModalComponent,
        // Remove these standalone components from exports
        // ActionEditModalComponent,
        // ResponseControllerComponent,
        ScoreTrendsNewComponent,
        ScoreDrilldownTableNewComponent,
        ScoreDrilldownBarChartComponent,
        SentimentAnalysisComponent
    ],
    imports: [
        RouterModule,
        CommonModule,
        NgbModule,
        NgxDaterangepickerMd.forRoot(),
        ReactiveFormsModule,
        FormsModule,
        DragDropModule,
        // BrowserAnimationsModule, // Keep animations module only in root AppModule
        // EngagementStackbarComponent,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        LtmsDashboardThemesComponent,
        LitmusFooterComponent,
        LitmusHeaderComponent,
        WebPushNotificationComponent,
        SideBarComponent,
        MenuItemComponent,
        CalendarComponent,
        LtmsFilterDrawComponent,
        AddFiltersButtonComponent,
        HierarhyFilterButtonComponent,
        ActiveFiltersChipsComponent,
        LtmsGlobalFilterSideBarComponent,
        LtmsGlobalFilterByHierarchyComponent,
        LtmsGlobalFilterByDimensionComponent,
        LtmsActiveGlobalFilterComponent,
        LtmsSavedGlobalFilterComponent,
        DoughnutViewComponent,
        ProgressBarComponent,
        LtmsDoughnutChartViewComponent,
        LtmsGroupBarChartViewComponent,
        ChangeAccessLevelComponent,
        ChangePasswordComponent,
        LtmsDropdownComponent,
        LtmsDataTableComponent,
        LtmsLineChartViewComponent,
        LtmsBarChartViewComponent,
        // LoaderComponent
        OrderByPipe,
        IndianNumberFormatPipe,
        LtmsWidgetToolsComponent,
        TooltipComponent,
        LtmsDownloadWidgetComponent,
        LtmsDaterangePickerComponent,
        LtmsTooltipDirective,
        LtmsLoaderComponent,
        LtmsDataTableV2Component,
        LtmsResizableDirective,
        LitmusMiniRaterComponent,
        NpsMiniRaterComponent,
        LtmsDrilldownTableComponent,
        LtmsCustomTabComponent,
        EngagementLiteComponent,
        EngagementProComponent,
        EngagementDetailsComponent,
        EngagementStackbarComponent,
        EngagementDoughnutChartComponent,
        EngagementCardsComponent,
        LtmsErrorComponent,
        FeedDetailPanelComponent,
        // LtmsSearchBoxComponent,
        ResponsePanelComponent,
        InformationPanelComponent,
        ChatPanelComponent,
        HistoryPanelComponent,
        VerbatimHomeComponent,
        LtmsBannerComponent,
        ScoreSummaryComponent,
        ScoreTrendsComponent,
        ScoreDetailsComponent,
        // LitmusDropdownComponent,
        LtmsCustomFieldRenderComponent,
        HuddleCreationComponent,
        LitmusFeedListViewComponent,
        ScoreDetailsTableComponent,
        ScoreDropdownMenuComponent,
        ScoreSummaryNpsMeterComponent,
        ScoreDoughnutChartComponent,
        ScoreComparisonComponent,
        ScoreWidgetComponent,
        ScoreSearchBarComponent,
        ScoreComparisonNpsMeterComponent,
        ScoreTableComponent,
        ScoreOverlayEffectComponent,
        ScoreLineChartComponent,
        ScoreBarChartComponent,
        LitmusResponseDownloaderComponent,
        // DownloadService
        RelationshipViewPanelComponent,
        ScoreQuestionDetailsComponent,
        ScoreQuestionComponent,
        ScoreCustomComponent,
        ScoreOverviewComponent,
        OverviewTableComponent,
        ScoreQuestionBarChartComponent,
        ScoreQuestionTabHorizonatalBarChartComponent,
        HolidayCalendarComponent,
        HuddleDropdownMenuComponent,
        SuggestionEditModalComponent,
        EngagementSummaryComponent,
        EngagementRecordsSummaryDrilldownComponent,
        EngagementChannelPerformanceComponent,
        ScoreTrendsNewComponent,
        ScoreDrilldownTableNewComponent,
        ScoreDrilldownBarChartComponent,
        SentimentAnalysisComponent
    ],
    providers: [
        provideHttpClient(withInterceptorsFromDi())
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
